.checklist {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.checklist li {
  display: flex;
  gap: 1rem;
}
